/**
 * Service-worker → extension page broadcasts handled by dedicated listeners
 * (chromeAuthBridge, mfa-recaptcha-bridge, popup messaging). useExtensionUtil
 * must ignore these to avoid noisy "Unhandled SW message" logs.
 *
 * Keep in sync with trove-extension/src/bg/trove-bg-process-request.ts and
 * trove-extension/src/popup/utils/messaging.ts.
 */
export const EXTENSION_SW_IGNORED_MESSAGE_TYPES = new Set([
  'AUTH_STATE_CHANGED',
  'POPUP_SIGN_IN_RESPONSE',
  'POPUP_SIGN_UP_RESPONSE',
  'POPUP_SIGN_OUT_RESPONSE',
  'POPUP_AUTH_STATE_RESPONSE',
  'POPUP_MFA_VERIFY_RESPONSE',
  'POPUP_MFA_SEND_SMS_RESPONSE',
  'POPUP_MFA_CANCEL_RESPONSE',
  'POPUP_API_RESPONSE',
  'MFA_RECAPTCHA_REQUEST',
  'MFA_RECAPTCHA_RESPONSE',
  'MFA_RECAPTCHA_RESET',
]);

export function isExtensionSwIgnoredMessage(msg: unknown): boolean {
  if (typeof msg !== 'object' || msg === null) return false;
  const type = (msg as { type?: string }).type;
  return typeof type === 'string' && EXTENSION_SW_IGNORED_MESSAGE_TYPES.has(type);
}
